export const shortenText = (text: string, frontChars = 5, backChars = 4): string => {
  if (text.length <= frontChars + backChars + 3) {
    return text
  }
  const front = text.slice(0, frontChars)
  const back = text.slice(-backChars)
  return `${front}...${back}`
}
